/* jshint esversion: 6, -W097 */
/* globals require */
(function(angular) {
    'use strict';
    var app = angular.module('enervee');

    app.directive('deleteAccountModal', [function() {
        return {
            restrict: 'E',
            controller: [
                '$scope',
                'DeleteAccountService',
                '$timeout',
                'IndexService',
                '$state',
                'AccountAuthService',
                function (
                    $scope,
                    DeleteAccountService,
                    $timeout,
                    IndexService,
                    $state,
                    AccountAuthService
                ) {

                    $scope.deleteAccount = function(password) {

                        DeleteAccountService.deleteAccount(password).then(function() {
                            var _deleteAccountResponse = DeleteAccountService.getDeleteAccountResponse();

                            if (_deleteAccountResponse.success === true) {

                                $scope.successMessage = "Your account it deleted";

                                $scope.password = "";

                                $timeout(function () {
                                    IndexService.closeModal('#modal-delete-account');
                                    $timeout(function () {
                                        AccountAuthService.logout();
                                    }, 500);

                                }, 1500);

                            } else {

                                $scope.errorMessages = [];

                                for (var error_key in _deleteAccountResponse.error) {
                                    if (error_key == 'password'){
                                        var passwordErrorText = "your password is incorrect";
                                        $scope.errorMessages.push(passwordErrorText);
                                    } else {
                                        $scope.errorMessages = $scope.errorMessages.concat(
                                            _deleteAccountResponse.error[error_key]);
                                    }
                                }

                            }

                        });
                    };
                }],
            template: require('@app/shared/modals/deleteAccount/deleteAccountView.html'),
        };
    }]);

})(angular);